export enum FilterSearchModelType {
  RECORDING = 'recording',
  ANNOTATION = 'annotation',
}
